import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div<{ isSmall?: boolean; isFocused: boolean; error?: boolean; notification?: boolean; }>`
    height: ${({ theme, isSmall }) => (isSmall ? theme.form.height.small : theme.form.height.normal)}rem;
    border-radius: 50px;
    display: flex;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.white};

    ${({ theme, isFocused, error, notification }) => {
        if (error) {
            return css`
            border: 2px solid ${theme.colors.red};
        `;
        } else if (notification) {
            return css`
            border: 2px solid ${theme.colors.warning};
        `;
        } else if (isFocused) {
            return css`
            border: 2px solid ${theme.colors.secondary};
        `;
        } else {
            return css`
            border: 2px solid ${theme.colors.accent};
        `;
        }
    }}
`;

export const FormControl = styled.input<{ isSmall?: boolean }>`
    width: 100%;
    height: 100%;
    border: none;
    padding: 12px 24px;
    font-size: ${({ theme, isSmall }) => (isSmall ? theme.form.fontSize.small : theme.form.fontSize.normal)}rem;
    font-weight: 400;

    &:focus {
        outline: none;
    }

    &:hover {
        border-color: ${({ theme }) => theme.greys[100]};
    }

    ::placeholder {
        color: ${({ theme }) => theme.greys[300]};
    }
`;

export const InlineWrapper = styled.div<{ isSmall?: boolean }>`
    height: 100%;
    width: ${({ theme, isSmall }) => (isSmall ? theme.form.height.small : theme.form.height.normal)}rem;
    flex: 0 0 ${({ theme, isSmall }) => (isSmall ? theme.form.height.small : theme.form.height.normal)}rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
`;
